import getCollection from './getCollection'
import getDataById from 'actions/base/getDataById'

const getGroup = async (id) => getDataById(id, getCollection)

export default getGroup
